import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart, faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import { faUserCircle } from "@fortawesome/free-regular-svg-icons";
import { Popover } from "antd";

const Content = (favoUsers) => {
  return (
    <div>
      {favoUsers?.map((item) => (
        <div key={item.user_id}>
          <FontAwesomeIcon color="#666" icon={faUserCircle} /> {item.login_name}
        </div>
      ))}
    </div>
  );
};

export function Favour({ favoUsers }) {
  return (
    <Popover
      placement="bottomLeft"
      content={() => Content(favoUsers)}
      title="Liked By:"
      trigger="hover"
    >
      <div className="bg-[#3b82f6] w-5 h-5 rounded-full flex justify-center items-center">
        <FontAwesomeIcon
          color={"#fff"}
          className="w-[10px] h-[10px] transition transform hover:scale-110 "
          icon={faThumbsUp}
        />
      </div>
    </Popover>
  );
}

export function PersonalFavourite({ isFavourite, onClick }) {
  if (!isFavourite) return null;
  
  const handleClick = (event) => {
    event.stopPropagation();
    onClick && onClick();
  };
  
  return (
    <div className="bg-[#dc2626] w-5 h-5 rounded-full flex justify-center items-center">
      <FontAwesomeIcon
        color={"#fff"}
        onClick={handleClick}
        className="w-[10px] h-[10px] transition transform hover:scale-110 cursor-pointer"
        icon={faHeart}
      />
    </div>
  );
}

export default function Mark({
  id,
  handleItemClick,
  publicMark = 0,
}) {
  const [publicMarkValue, setPublicMarkValue] = useState((publicMark ?? 0).toString());

  const colorMap = {
    0: "",
    1: "#ABEBC6",
    2: "#F9E79F",
    3: "#F8C471",
    4: "#EC7063",
    5: "#CB4335",
    6: "#7D3C98",
  };

  useEffect(() => {
    setPublicMarkValue((publicMark ?? 0).toString());
  }, [publicMark]);

  function handleClick(event) {
    event.stopPropagation();
    handleItemClick(id);
  }

  return (
    <div className="absolute w-4 h-4 top-4 right-4">
      <div
        onClick={handleClick}
        className="w-full h-full rounded-full transition transform hover:scale-110 cursor-pointer"
        style={{
          backgroundColor: colorMap[publicMarkValue],
          border: publicMarkValue === "0" ? "2px solid #8e8d92" : "none",
        }}
      />
    </div>
  );
}
